import { render, staticRenderFns } from "./ModalConfirmacaoRetornarRequisicaoDeCompra.vue?vue&type=template&id=2bca1ed0"
import script from "./ModalConfirmacaoRetornarRequisicaoDeCompra.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalConfirmacaoRetornarRequisicaoDeCompra.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports